import React, { PropsWithChildren } from "react";
import useIsMounted from "~/common/useIsMounted";

interface DocumentProps {
  title: string;
  link: string;
  isExternal: boolean;
}

const Document: React.FC<PropsWithChildren<DocumentProps>> = ({
  title = "",
  link = "",
  isExternal,
  children,
}) => {
  const isMounted = useIsMounted();

  if (isExternal && !isMounted) {
    return <div aria-label={title}>{children}</div>;
  }

  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={title}
      onAuxClick={isExternal ? (e) => e.preventDefault() : undefined}
      onContextMenu={isExternal ? (e) => e.preventDefault() : undefined}
      data-toggle={isExternal ? "externalLinkModal" : undefined}
    >
      {children}
    </a>
  );
};

export default Document;
